<template lang="pug">
    div.flexRow
        Input(v-model="brandTitle" @on-change="$emit('input',brandTitle)")
        Button(@click="applyDefaultValue") {{$t("groupPattern.applyDefault")}}   
</template>
<script>
import { getGroupPrefs } from "@/api/group";

export default {
    props: ["value", "groupName", "disabled"],
    data() {
        return {
            defaultBranTitle: "",
            brandTitle: ""
        };
    },
    watch: {
        brandTitle() {
            this.$emit("input", this.brandTitle);
        },
        value: {
            deep: true,
            handler: function(newVal, oldVal) {
                this.brandTitle = Object.assign(newVal, "");
            }
        }
    },
    methods: {
        getPrefsByType(type) {
            getGroupPrefs({ type: type, groupName: this.groupName })
                .then(result => {
                    this.defaultBranTitle = result.data.brandTitle;
                })
                .catch(err => {});
        },
        applyDefaultValue() {
            this.brandTitle = Object.assign(this.defaultBranTitle, "");
            this.$emit("input", this.brandTitle);
        }
    },
    mounted() {
        this.getPrefsByType("default");
        this.brandTitle = Object.assign(this.value, "");
    }
};
</script>


// WEBPACK FOOTER //
// src/components/GroupPatternFormItems/InputWithButton.vue